"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const Asset = require("../types/migration/Asset.cjs");
const Document = require("../types/migration/Document.cjs");
const link = require("../types/value/link.cjs");
const richText = require("../types/value/richText.cjs");
const isValue = require("./isValue.cjs");
const contentRelationship = (value) => {
  return value instanceof Document.PrismicMigrationDocument || isValue.prismicDocument(value) || typeof value === "object" && value !== null && "link_type" in value && value.link_type === link.LinkType.Document && "id" in value && (contentRelationship(value.id) || typeof value.id === "function");
};
const image = (value) => {
  return value instanceof Asset.PrismicMigrationAsset || typeof value === "object" && value !== null && "id" in value && Object.values(value).every((maybeThumbnail) => maybeThumbnail instanceof Asset.PrismicMigrationAsset);
};
const linkToMedia = (value) => {
  return typeof value === "object" && value !== null && "id" in value && value.id instanceof Asset.PrismicMigrationAsset && "link_type" in value && value.link_type === link.LinkType.Media;
};
const rtImageNode = (value) => {
  return typeof value === "object" && value !== null && "id" in value && value.id instanceof Asset.PrismicMigrationAsset && "type" in value && value.type === richText.RichTextNodeType.image;
};
exports.contentRelationship = contentRelationship;
exports.image = image;
exports.linkToMedia = linkToMedia;
exports.rtImageNode = rtImageNode;
//# sourceMappingURL=isMigrationValue.cjs.map
